import React, { useState, useEffect } from 'react';
import ThemeSelector from './ThemeSelector.js';  // Adjust path if needed

const ThemePage = () => {
  const [selectedThemeId, setSelectedThemeId] = useState(1);

  useEffect(() => {
    localStorage.setItem("themeId", selectedThemeId);

    document.body.className = '';
    document.body.classList.add('theme-' + selectedThemeId);
    
  }, [selectedThemeId]);

  return (
    <div style={{ padding: 40 }}>
      <h1>Pick Your Theme</h1>
      <ThemeSelector selectedThemeId={selectedThemeId} onThemeChange={setSelectedThemeId} />
    </div>
  );
};

export default ThemePage;
